/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Rotate Icon component.
 */
export const MaterialRotateIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19574)'>
        <path d='M7.33986 6.40977L0.859863 12.8998L7.34986 19.3798L13.8399 12.8998L7.33986 6.40977ZM3.68986 12.8998L7.34986 9.23977L10.9999 12.8998L7.33986 16.5598L3.68986 12.8998ZM19.3599 6.63977C17.6099 4.87977 15.2999 3.99977 12.9999 3.99977V0.759766L8.75986 4.99977L12.9999 9.23977V5.99977C14.7899 5.99977 16.5799 6.67977 17.9499 8.04977C20.6799 10.7798 20.6799 15.2198 17.9499 17.9498C16.5799 19.3198 14.7899 19.9998 12.9999 19.9998C12.0299 19.9998 11.0599 19.7898 10.1599 19.3898L8.66986 20.8798C10.0199 21.6198 11.5099 21.9998 12.9999 21.9998C15.2999 21.9998 17.6099 21.1198 19.3599 19.3598C22.8799 15.8498 22.8799 10.1498 19.3599 6.63977Z' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_14304_19574'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MaterialRotateIcon;
